export class SetPreferencesReminder {
  private isVisible: boolean;
  constructor() {
    this.isVisible = true;
  }
}

class SetPreferencesReminderComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {};
    this.controller = SetPreferencesReminder;
    this.templateUrl =
      'capability-ng-scheduler/src/views/components/set_preferences_reminder/set_preferences_reminder.html';
  }
}
angular.module('capability-ng-scheduler').component('setPreferencesReminder', new SetPreferencesReminderComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/set_preferences_reminder/set_preferences_reminder.ts